import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './header.html' with { type: 'html' };

export default {
	name: 'CHeader',
	components: {
		cSvg
	},
	props: {
		ariaDescribeId: {
			type: String,
			default: null
		},
		description: {
			type: String,
			default: null
		},
		headline: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: null
		},
		isCenterAligned: {
			type: Boolean,
			default: false
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		page: {
			type: Object,
			default: null
		},
		payment: {
			type: Object,
			default: null
		},
		subHeadline: {
			type: String,
			default: null
		}
	},
	computed: {
		iconName() {
			if (this.icon) {
				return this.icon;
			} else {
				return this.payment.isOffline ? 'header-time-limit' : 'header-tick';
			}
		},
		centerContent() {
			return this.isCenterAligned || this.isThankYouPage;
		},
		hasBiggerPadding() {
			return this.isThankYouPage;
		},
		isIconDisplayed() {
			return this.icon || this.isThankYouPage;
		},
		isThankYouPage() {
			return this.page?.number === 4;
		}
	},
	template
};
